import React from "react"
import GroupGameViewStyle from "./GroupGameView.module.css"


export default function GroupGameViewMentorPlayerSelectorTile(props) {
    return <div className={
        props.player.id === props.selectedPlayer ? GroupGameViewStyle.playerSelectorSelected : GroupGameViewStyle.playerSelector
    }
                onClick={() => props.setSelectedPlayer(props.player.id)}>
        {props.player.name.slice(0, 25)} [{props.player.chip_char}]
    </div>
}